import { render, staticRenderFns } from "./sectionDataPreviewScheduleShipment.vue?vue&type=template&id=151c8f2c"
import script from "./sectionDataPreviewScheduleShipment.vue?vue&type=script&lang=js"
export * from "./sectionDataPreviewScheduleShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports